import { createBrowserRouter, Navigate, useLocation } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { Layout } from './components/Layout';
import { Home } from './routes/Home';
import { Learn } from './routes/Learn';
import { NotFound } from './routes/NotFound';
import { PlayIce } from './routes/PlayIce';
import { PlayIceBot } from './routes/PlayIceBot';
import { PlayOnlineMatch, PlayOnlineSetup } from './routes/PlayOnline';

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/play/local', element: <PlayIce /> },
      { path: '/play/ice', element: <ToLocal /> },
      { path: '/play/bot', element: <PlayIceBot /> },
      { path: '/play/online', element: <PlayOnlineSetup /> },
      { path: '/play/:matchId', element: <PlayOnlineMatch /> },
      { path: '/learn', element: <Learn /> },
      // The mountain prototype is not part of the release; its old links go home.
      { path: '/mountain/*', element: <Navigate to="/" replace /> },
      { path: '/m/:seed', element: <Navigate to="/" replace /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

/** `/play/ice` was the ice game's first address: keep old links (and their lake) working. */
function ToLocal() {
  const { search } = useLocation();
  return <Navigate to={`/play/local${search}`} replace />;
}

export function App() {
  return <RouterProvider router={router} />;
}
